import React from 'react';

import Link from 'common/Link';
import UppercaseHeader from 'common/UppercaseHeader';
import nbspLastSpace from 'common/util/nbspLastSpace';
import styles from 'css-module/components/www/_LandingCaseStudyHeading.module.scss';

type Props = {
  title: string;
};

const LandingCaseStudyHeadingText = ({ title }: Props) => {
  return (
    <div className={styles.copy}>
      <UppercaseHeader className={styles.subheading}>Customer story</UppercaseHeader>
      <h1 className={styles.heading}>{nbspLastSpace(title)}</h1>
      <Link className="LandingGlobal__cta" to="/register">
        Get started
      </Link>
    </div>
  );
};

export default LandingCaseStudyHeadingText;
